// Client V2 common imports
const {
  searchCollectionsHref,
  searchInterestsHref,
  searchPeopleHref,
  searchPostsHref
} = require('client-v2/common/containers/search-form/actions')
const { navigate } = require('client-v2/common/state/router/actions')

// URL helpers

/**
 * Creates a navigation action dispatcher from a href helper function
 * @param {(query: string) => string} queryToHref
 * @returns {function} Redux Thunk
 */
function navigateToSearchHref(queryToHref) {
  return function ({ event, query }) {
    const href = queryToHref(query)
    return function (dispatch) {
      dispatch(navigate({ event, href }))
    }
  }
}

// Exports

module.exports = {
  searchCollectionsHref,
  searchInterestsHref,
  searchPeopleHref,
  searchPostsHref
}

// Define and export navigation dispatchers
Object.entries({
  navigateToSearchCollections: searchCollectionsHref,
  navigateToSearchInterests: searchInterestsHref,
  navigateToSearchPeople: searchPeopleHref,
  navigateToSearchPosts: searchPostsHref
}).forEach(([ key, value ]) => {
  module.exports[key] = navigateToSearchHref(value)
})
